import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2 5C2 4.05719 2 3.58579 2.29289 3.29289C2.58579 3 3.05719 3 4 3H20C20.9428 3 21.4142 3 21.7071 3.29289C22 3.58579 22 4.05719 22 5C22 5.94281 22 6.41421 21.7071 6.70711C21.4142 7 20.9428 7 20 7H4C3.05719 7 2.58579 7 2.29289 6.70711C2 6.41421 2 5.94281 2 5Z",
			fill: "#1C274C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0689 8.49993C20.2101 8.49999 20.3551 8.50005 20.5 8.49805V12.9999C20.5 16.7711 20.5 18.6568 19.3284 19.8283C18.183 20.9737 16.3552 20.9993 12.75 20.9999L12.75 13.9543L14.4425 15.8349C14.7196 16.1428 15.1938 16.1678 15.5017 15.8907C15.8096 15.6136 15.8346 15.1394 15.5575 14.8315L12.5575 11.4982C12.4152 11.3401 12.2126 11.2499 12 11.2499C11.7874 11.2499 11.5848 11.3401 11.4425 11.4982L8.44254 14.8315C8.16544 15.1394 8.1904 15.6136 8.49828 15.8907C8.80617 16.1678 9.28038 16.1428 9.55748 15.8349L11.25 13.9543L11.25 20.9999C7.64485 20.9993 5.81697 20.9737 4.67157 19.8283C3.5 18.6568 3.5 16.7711 3.5 12.9999V8.49805C3.64488 8.50005 3.78999 8.49999 3.93114 8.49993H20.0689Z",
			fill: "#1C274C"
		})
	]
});
const ForwardRef = forwardRef(SvgArchiveUp);
export { ForwardRef as ReactComponent };
